import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import BlockMaxWidthHandler from '@/shared/content/blocks/helpers/BlockMaxWidthHandler.vue';
import { B2BProductDetailTileModel } from '@/types/B2BcontentServerContract';
import ProductDetail from '@/shared/product/details/ui/ProductDetail.vue';
import useProductDetailTileModel from '@/shared/product/details/useProductDetailTileModel';
import { toRef } from 'vue';
import ProductDetailPurchase from '@/b2b/product/ui/ProductDetailPurchase.vue';
import { provideAddToBasketEndpoints } from '@/shared/product/upsell/useProductDetailUpsellAddToBasket';
import BlockList from '@/shared/content/blocks/helpers/BlockList.vue';
import { useAddToBasket } from '@/b2b/product/purchase/useAddToBasket';


export default /*#__PURE__*/_defineComponent({
  __name: 'B2BProductDetailTile',
  props: {
    content: null
  },
  setup(__props: any) {

const props = __props as {
    content: B2BProductDetailTileModel
}



const { handleProductTileModelChange } = useProductDetailTileModel();
const content = toRef(props, 'content');
const { addToBasket } = useAddToBasket();

handleProductTileModelChange(content);
provideAddToBasketEndpoints(addToBasket);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(BlockMaxWidthHandler, null, {
      default: _withCtx(() => [
        _createVNode(ProductDetail, null, {
          default: _withCtx(() => [
            _createVNode(ProductDetailPurchase)
          ]),
          _: 1
        }),
        _createVNode(BlockList, {
          blocks: _unref(content).tiles
        }, null, 8, ["blocks"])
      ]),
      _: 1
    })
  ]))
}
}

})